export interface LoadingDetails {
  isLoading: boolean;
  text: string;
  isUpdating?: boolean;
}
